import React, { Suspense, useEffect, useState } from 'react';

import { AppContext } from './utils/appContext';
import {
  HuniverseCardAccount,
  IAppContext,
  IAvailability,
  IAvailabilityRateCode,
  ICouponRateCodeStatamic,
  ICouponStatamic,
  IOrder,
  IPackageCode,
  ISearchParams,
  ITimeEstimate
} from './interfaces/bookingContext';
import axios, { AxiosError, AxiosResponse, CancelTokenSource } from 'axios';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
import updateLocale from 'dayjs/plugin/updateLocale.js';

import ReCAPTCHA from 'react-google-recaptcha';

import { IChildCategory, IProfile, IRoomType } from './interfaces/suite8';
import {
  getAvailabilityRequest,
  getChildCategories,
  getMinStay,
  getOpeningsDates,
  getPromoCode,
  getRoomTypes,
  getTimeEstimates,
  getUser,
  validateToken
} from './utils/requests';
import { Backdrop, CircularProgress } from '@mui/material';
import { FiltersModel, ProfileModel } from './components/utils/constants';
import { useHistory, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  devToolsShowIf,
  getBoardInfo,
  getCurrentWebsite,
  getDataFromUrl,
  getMoreInfo,
  getPropertiesByDestination,
  getProperty as getPropertyHelper,
  getTermsInfo,
  setIsVisible
} from './utils/helpers';
import { IAccommodationBoardsInfo, IAccommodationMoreInfo, IRateTerms } from './interfaces/huWebsite';

import { useCookies } from 'react-cookie';
import { v4, validate, version } from 'uuid';
import dayjs from 'dayjs';

declare global {
  interface Window {
    current_lang: string;
  }
}

dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Rome');

const Main = (props: { children: React.ReactNode }) => {
  let history = useHistory();
  const [website, setWebsite] = useState(getCurrentWebsite());
  const [language, setLanguage] = useState(
    window.current_lang || localStorage.getItem('lang') || 'en'
  );
  const [childCategories, setChildCategories] = useState<IChildCategory[]>([]);
  const [backdropIsOpen, setBackdropIsOpen] = React.useState(false);
  const [isLoadingAvailability, setIsLoadingAvailability] = useState<boolean>(false);
  const [minStay, setMinStay] = useState('');
  const [isLoadingEnded, setIsLoadingEnded] = useState<boolean>(true);
  const [payment, setPayment] = useState<string>('');
//  let [recaptcha, setRecaptcha] = useState<string | null>(null);

  let query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    const property = query.get('property') || searchForm[orderIndex].property;
    const destination = query.get('destination') || searchForm[orderIndex].destination;
    const urlSearchParams = new URLSearchParams(window.location.search);

    const params = Object.fromEntries(urlSearchParams.entries());

    if (params['redirect_status']) {
      if (params['redirect_status'] === 'succeeded') {
        history.push('/accepted');
      } else {
        history.push('/denied');
      }
    }

    if (destination) {
      searchForm[0].destination = destination;
      setSearchForm([...searchForm]);
    }

    if (property) {
      searchForm[0].property = property;
      searchForm[0].destination = 'all';
      setSearchForm([...searchForm]);

      // TODO Maybe to delete...
      getMoreInfo(property).then((res: IAccommodationMoreInfo[]) => {
        setMoreInfo(res);
      });
    }
  }, []);

  const [openings, setOpenings] = useState([]);

  useEffect(() => {
    let property;
    if (website === 'EV') {
      property = getProperty('AM');
    } else {
      property = getProperty(website);
    }

    if (property) {
      getOpeningsDates(property.openings_end_point).then((response: AxiosResponse) => {
        if (response.status === 200) {
          setOpenings(response.data);
        }
      });
    }
  }, []);

  const [autoStart, setAutoStart] = useState<null | boolean>(null);

  useEffect(() => {
    searchForm.map((sF: ISearchParams) => {
      let categories: any = {};
      childCategories.forEach((c: IChildCategory) => {
        categories[c.ChildrenCategoriesCode] = Number(query.get(c.ChildrenCategoriesCode)) || 0;
      });

      sF.Child = categories;

      if (website !== 'HU' && website !== 'EV') {
        // sF.destination = 'sea'
        sF.property = website;
        getMoreInfo(sF.property).then((data: IAccommodationMoreInfo[]) => {
          setMoreInfo(data);
        });

        getBoardInfo(sF.property).then((data: IAccommodationBoardsInfo[]) => {
          setBoardInfo(data);
        });

        getTermsInfo(sF.property).then((data: IRateTerms[]) => {
          setRateTerms(data);
        });
      }

      return sF;
    });
    setSearchForm([...searchForm]);
    setAutoStart(true);
  }, [childCategories]);

  useEffect(() => {
    getChildCategories(website)
      .then((response: AxiosResponse<IChildCategory[]>) => {
        if (response.data && response.headers['content-type'] !== 'text/html') {
          setChildCategories(response.data.reverse());
        } else {
          setChildCategories([]);
        }
      })
      .catch(() => {
        setChildCategories([]);
      });
  }, []);

  useEffect(() => {
    i18n.changeLanguage(language).then();
    dayjs.updateLocale(language, {
      week: {
        dow: 1
      }
    });
  }, [language]);

  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    getUser().then((response: any) => {
      if (response) {
        // const statusResponse: AxiosResponse<HuniverseCardStatus> = response[0]
        const accountResponse: AxiosResponse<HuniverseCardAccount> = response[1];
        reservationHolder.GuestFirstname = accountResponse.data.firstName;
        reservationHolder.GuestName = accountResponse.data.lastName;
        reservationHolder.Gender = accountResponse.data.gender === 'male' ? 'M' : 'F';
        reservationHolder.Email = accountResponse.data.email;
        reservationHolder.Birthday = dayjs(accountResponse.data.birthDate);
        reservationHolder.Telephone = accountResponse.data.phone || '';
        setReservationHolder({ ...reservationHolder });

        setUser({
          customerId: response[0].data.customerId,
          points: response[0].data.points
        });
      }
    });
  }, []);

  const setDataFromUrl = () => {
    return getDataFromUrl(query);
  };

  const [searchForm, setSearchForm] = useState<ISearchParams[]>(() => setDataFromUrl());

  const [properties, setProperties] = useState<any[]>([]);

  useEffect(() => {
    setProperties([...getPropertiesByDestination(searchForm[orderIndex].destination)]);
  }, [searchForm]);

  useEffect(() => {
    if (
      searchForm[orderIndex].status === 'to_start' &&
      dayjs(query.get('GuestArrival'), 'DD.MM.YYYY', true).isValid() &&
      dayjs(query.get('GuestDeparture'), 'DD.MM.YYYY', true).isValid()
    ) {
      if (autoStart && properties.length > 0 && searchForm) {

        if (Number(query.get('CA1')) > 0) {
          searchForm[orderIndex].Child.CA1 = query.get('CA1');
        }

        if (Number(query.get('CA2')) > 0) {
          searchForm[orderIndex].Child.CA2 = query.get('CA2');
        }

        if (Number(query.get('CA3')) > 0) {
          searchForm[orderIndex].Child.CA3 = query.get('CA3');
        }

        if (Number(query.get('CA4')) > 0) {
          searchForm[orderIndex].Child.C4 = query.get('CA4');
        }

        setSearchForm([...searchForm])
        getAvailability().then();
      }
      // document.getElementById('search')?.click()
    }
  }, [autoStart, searchForm[0].Child]);

  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource[]>([
    axios.CancelToken.source()
  ]);

  let [availability, setAvailability] = useState<IAvailability[]>([]);
  const [availabilityFiltered, setAvailabilityFiltered] = useState<IAvailability[]>([]);
  const [roomTypes, setRoomTypes] = useState<any>([]);
  const [filters, setFilters] = useState<any>(FiltersModel);
  const [activeStep, setActiveStep] = React.useState(1);

  const [orders, setOrders] = useState<IOrder[]>([]);
  const [profiles, setProfiles] = useState<IProfile[]>([]);
  const [orderIndex, setOrderIndex] = useState<number>(0);
  const [coupon, setCoupon] = useState<any>(null);
  const [moreInfo, setMoreInfo] = useState<IAccommodationMoreInfo[]>([]);
  const [boardInfo, setBoardInfo] = useState<IAccommodationBoardsInfo[]>([]);
  const [rateTerms, setRateTerms] = useState<IRateTerms[]>([]);

  const [reservationHolder, setReservationHolder] = useState<IProfile>({
    ...ProfileModel,
    Language: language.toUpperCase()
  });
  const [appliedTo, setAppliedTo] = useState(0);

  const resetAvailability = () => {
    cancelAvailabilityRequest();
    if (searchForm[0].destination !== '') {
      searchForm[0].property = '';
      searchForm[0].status = 'to_start';
      setIsLoadingEnded(false);
      setSearchForm([...searchForm]);
    }

    setAvailability([]);
    setMinStay('');
  };

  const cancelAvailabilityRequest = () => {
    cancelTokenSource.map((cancelToken: CancelTokenSource) => cancelToken.cancel());
    setCancelTokenSource([]);
  };

  useEffect(() => {
    if (['EV', 'HU'].includes(website) && searchForm[orderIndex].property) {
      const property = String(searchForm[orderIndex].property);
      getMoreInfo(property).then((data: IAccommodationMoreInfo[]) => {
        setMoreInfo(data);
      });

      getBoardInfo(property).then((data: IAccommodationBoardsInfo[]) => {
        setBoardInfo(data);
      });

      getTermsInfo(property).then((data: IRateTerms[]) => {
        setRateTerms(data);
      });
    }
  }, [searchForm]);

  /**
   * Get availability
   */
  let [counterRequest, setCounterRequest] = useState(0);
  const [counterResponse, setCounterResponse] = useState(0);

  const isRoomPetFriendly = (rooms: IAccommodationMoreInfo[], roomType: string) => {
    return rooms.find( room => room.room_id.endsWith(roomType) && room.filters && room.filters.includes('pet-friendly'))
  }

  const getAvailability = async () => {
    if (!searchForm[orderIndex].GuestArrival && !searchForm[orderIndex].GuestDeparture) {
      return;
    }

    if (properties.length === 0) {
      return;
    }

    searchForm[orderIndex].status = 'searching';
    setSearchForm([...searchForm]);
    !isLoadingAvailability && setIsLoadingAvailability(true);

    let resultsAvailability: IAvailability[] = availability;
    let resultsRoomTypes: IRoomType[] = [];

    resultsAvailability = availability.filter((av: IAvailability) => av.OrderIndex !== orderIndex);

    let promoRes: any[] = [];
    if (searchForm[0].Coupon!.length > 3) {
      let couponUrls: string[] = [];

      for (const property of properties) {
        let url = property.coupon_end_point;
        if (searchForm[0].Coupon) {
          url += searchForm[0].Coupon.toUpperCase();
        }
        if (!couponUrls.includes(url)) {
          couponUrls.push(url);
        }
      }

      for await (const couponUrl of couponUrls) {
        const res = await getPromoCode(couponUrl);
        if (res.data) {
          promoRes = promoRes.concat(res.data);
          setCoupon([...promoRes]);
        }
      }
    }

    const source = axios.CancelToken.source();
    setCancelTokenSource([...cancelTokenSource, source]);


    for (const property of properties) {
      if (website === 'EV' && counterRequest > 0) return;

      setCounterRequest(counterRequest++);

      const requestArray = [getRoomTypes(property.code)];

      let recaptcha = await recaptchaRef.current.executeAsync();

      requestArray.push(
        getAvailabilityRequest(property.property, searchForm[orderIndex], null, source, recaptcha)
      );

      for (const p of promoRes) {
        for (const rate of p.lista_ratecode) {
          recaptcha = await recaptchaRef.current.executeAsync()
          requestArray.push(
            getAvailabilityRequest(
              property.property,
              searchForm[orderIndex],
              rate.RateCode,
              source,
              recaptcha
            )
          );
        }
      }

      axios
        .all(requestArray)
        .then(
          axios.spread((...responses) => {
            let rt = responses[0].data;
            rt.map((a: IRoomType) => (a.Property = property.code));
            if (rt.length > 0) {
              resultsRoomTypes = resultsRoomTypes.concat(rt);
              setRoomTypes(resultsRoomTypes);
            }

            let av: any[] = [];

            responses.forEach((response: any, index: number) => {
              if (index !== 0) {
                av = av.concat(response.data);
              }
            });

            if (website === 'EV') {
              av.map((a: IAvailability) => {
                a.Property = a.RoomTypeShortDesc.slice(0, 2);
                a.OrderIndex = orderIndex;
                return a;
              });

              av = av.filter((a: IAvailability) => {
                return !!properties.find((p: any) => p.code === a.Property);
              });
            } else {
              av.map((a: IAvailability) => {
                a.Property = property.code;
                a.OrderIndex = orderIndex;
                return a;
              });
            }

            if (property.roomTypeFilters.length > 0) {
              av = av.filter((a: IAvailability) => {
                for (let filter of property.roomTypeFilters) {
                  if (a.RoomTypeShortDesc.indexOf(filter) > -1) {
                    return true;
                  }
                }
                return false;
              });
            }

            if (av.length > 0 && rt.length > 0) {
              rt.forEach((r: IRoomType) => {
                av.filter(
                  (a: IAvailability) => a.RoomTypeShortDesc === r.RoomTypeShortDesc
                ).forEach((a: IAvailability) => {
                  // Check if is a promo
                  if (promoRes.length > 0) {
                    a.RateCodes.map((RateCode: IAvailabilityRateCode) => {
                      RateCode.RateCodeCouponStatamic =
                        promoRes.find((couponStatamic: ICouponStatamic) =>
                          couponStatamic.lista_ratecode.find(
                            (couponListRateCode: ICouponRateCodeStatamic) =>
                              couponListRateCode.RateCode === RateCode.RateCode
                          )
                        ) || null;
                      return RateCode;
                    });
                  }

                  const sameAccommodation = resultsAvailability.find(
                    (resA: IAvailability) =>
                      resA.RoomTypeShortDesc === a.RoomTypeShortDesc &&
                      resA.OrderIndex === a.OrderIndex
                  );
                  if (sameAccommodation) {
                    sameAccommodation.RateCodes = sameAccommodation.RateCodes.concat(a.RateCodes);
                    sameAccommodation.Price = a.Price;
                  } else {
                    resultsAvailability.push(a);
                  }
                });
              });

              if (searchForm[0].property === 'PA' && searchForm[0].Pets) {
                resultsAvailability = resultsAvailability.filter( (av: IAvailability) => !av.RoomTypeShortDesc.startsWith('CA') )
              }

              if (searchForm[0].Pets) {
                resultsAvailability = resultsAvailability.filter( (av: IAvailability) => isRoomPetFriendly(moreInfo, av.RoomTypeShortDesc) )
              }

              resultsAvailability = setIsVisible(resultsAvailability, searchForm[0]).filter( availability => availability.RateCodes.find(rate => rate.isVisible) );
              setAvailability([...resultsAvailability]);
              setAvailabilityFiltered(
                resultsAvailability.filter((avF: IAvailability) => avF.OrderIndex === orderIndex)
              );
            }

            if (resultsAvailability.length === 0) {
              getMinStay(
                website,
                dayjs(searchForm[0].GuestArrival).format('DD.MM.YYYY'),
                dayjs(searchForm[0].GuestDeparture).format('DD.MM.YYYY')
              )
                .then((response: AxiosResponse) => {
                  setMinStay(response.data.RateMinLOS);
                })
                .catch();
            }

            setIsLoadingAvailability(false);
            searchForm[orderIndex].status = 'ready';
            setSearchForm([...searchForm]);
            setCounterResponse(counterResponse + 1);
          })
        )
        .catch((error: AxiosError<any>) => {
          console.log('error');

          if (
            error.response &&
            error.response.status === 429 &&
            error.response.data &&
            error.response.data.id
          ) {
            setServerBusy(true);
            setServerRequestID(error.response.data.id);
          }

          if (error?.message !== 'canceled') {
            setIsLoadingAvailability(false);
            searchForm[orderIndex].status = 'ready';
            setSearchForm([...searchForm]);
            setCounterResponse(counterResponse + 1);
          }
          //history.push('/maintenance');
        });

    }

  };

  const [cookies, setCookie, removeCookie] = useCookies<any>(['cookie-name']);

  useEffect(() => {
    if (
      !cookies['hu-bol-uuid'] ||
      !validate(cookies['hu-bol-uuid']) ||
      !version(cookies['hu-bol-uuid'])
    ) {
      setCookie('hu-bol-uuid', v4(), { maxAge: 3600 * 24 * 30 * 12 });
    }
  }, []);

  const getTotalPrice = (multiplier = 0): number => {
    let sum: number = 0;

    orders.forEach((order: IOrder) => {
      sum += order.TotalStay;
      order.PackageCode.forEach((pack: IPackageCode) => {
        sum += pack.CalculatedPrice || 0;
      });
    });

    if (orders[0].use_hc_points && user) {
      sum -= Math.min(sum, user.points / 4);
    }

    if (multiplier) {
      sum *= multiplier;
    }

    return parseFloat(sum.toFixed(2));
  };

  const getDepositPrice = (): number => {
    let sum: number = 0;

    orders.forEach((order: IOrder) => {
      sum += order.TotalStay;
      order.PackageCode.forEach((pack: IPackageCode) => {
        sum += pack.CalculatedPrice || 0;
      });

      if (order.RateCode.indexOf('_AX') > 0) {
        sum = 100;
      } else {
        sum *= 0.3;
      }
    });

    if (orders[0].use_hc_points && user) {
      sum -= Math.min(sum, user.points / 4);
    }

    return Number.parseFloat(sum.toFixed(2));
  };

  const getProperty = (property = '') => {
    if (property) {
      return getPropertyHelper(property);
    } else if (orders.length === 0 && website === 'EV') {
      return getPropertyHelper('AM');
    } else if (orders.length > 0 && orders[0].Property === 'EV') {
      property = orders[0].RoomType.slice(0, 2);
    } else if (orders.length > 0) {
      property = orders[0].Property;
    }
    return getPropertyHelper(property);
  };

  const [serverIsBusy, setServerBusy] = useState<boolean>(false);
  const [serverRequestID, setServerRequestID] = useState<number | null>(null);
  const [estimateTime, setEstimateTime] = useState<ITimeEstimate | null>(null);

  const DevTools = React.lazy(() => import('./components/dev_tools/DevTools'));

  useEffect(() => {
    getTimeEstimates().then((response: AxiosResponse<ITimeEstimate>) =>
      setEstimateTime(response.data)
    );
  }, []);

  const value: IAppContext = {
    isLoadingAvailability,
    setIsLoadingAvailability,
    isLoadingEnded,
    setIsLoadingEnded,
    website,
    setWebsite,
    language,
    setLanguage,
    searchForm,
    setSearchForm,
    orders,
    setOrders,
    availability,
    setAvailability,
    getAvailability,
    resetAvailability,
    roomTypes,
    setRoomTypes,
    filters,
    setFilters,
    availabilityFiltered,
    setAvailabilityFiltered,
    profiles,
    setProfiles,
    orderIndex,
    setOrderIndex,
    cancelAvailabilityRequest,
    childCategories,
    reservationHolder,
    setReservationHolder,
    appliedTo,
    setAppliedTo,
    activeStep,
    setActiveStep,
    minStay,
    coupon,
    user,
    getTotalPrice,
    getDepositPrice,
    openings,
    moreInfo,
    setMoreInfo,
    boardInfo,
    setBoardInfo,
    rateTerms,
    backdropIsOpen,
    setBackdropIsOpen,
    getProperty,
    serverIsBusy,
    setServerBusy,
    serverRequestID,
    setServerRequestID,
    estimateTime,
    payment,
    setPayment
  };

  const recaptchaRef = React.useRef({} as ReCAPTCHA);

  return (
    <AppContext.Provider value={value}>
      <ReCAPTCHA
        sitekey="6LcEbVMpAAAAALlIsYrlzmzjYspRIV8dbja5f2fx"
        size={'invisible'}
        ref={recaptchaRef}
        hl={language}
      />
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={'Loading...'}>
          <main>{props.children}</main>
        </Suspense>

        <ToastContainer />
        <Backdrop open={backdropIsOpen} style={{ zIndex: 999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </I18nextProvider>
    </AppContext.Provider>
  );
};

export default Main;
